import { useState } from "react";

const faqs = [
  {
    q: "Is ItaobuySpreadsheet free?",
    a: "It depends on access level, but most sheets are freely structured for browsing. You can explore product categories and supplier data without any upfront payment, making the itaobuy spreadsheet an accessible entry point for new dropshippers and experienced sellers alike.",
  },
  {
    q: "Is it safe to use ItaobuySpreadsheet?",
    a: "Yes, absolutely. The itaobuy spreadsheet system only organizes supplier data and product information for comparison purposes. All actual purchases are made through secure third-party platforms, so your payment information and personal details are never stored within the spreadsheet system itself.",
  },
  {
    q: "Who uses ItaobuySpreadsheet?",
    a: "Dropshippers, Amazon sellers, Shopify store owners, and global resellers form the core user base. Whether you are running a small boutique shop or managing a large-scale eCommerce operation, the itaobuy spreadsheet provides structured product data that fits your workflow.",
  },
  {
    q: "How often is the product data updated?",
    a: "The itaobuy spreadsheet product sheets are refreshed on a regular basis to ensure pricing accuracy and availability data remain current. Most categories see updates weekly, with high-demand categories refreshed even more frequently to keep you ahead of market trends.",
  },
  {
    q: "Can I request a specific product category?",
    a: "The current itaobuy spreadsheet already covers 14 major categories from Shoes to Perfumes. If you need a category that is not yet covered, the system is continuously expanding based on buyer demand and market shifts in the global dropshipping landscape.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-xs md:text-sm font-medium text-foreground-500 tracking-[0.15em] uppercase mb-3 whitespace-nowrap">
            Common Questions
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-[1.15]">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="border border-background-200/60 rounded-xl overflow-hidden bg-background-100"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-background-50/80 transition-colors"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.q}
                </span>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`text-lg text-foreground-500 transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </span>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}